import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import { getPalette, getPaletteAsRawColors } from 'owa-theme';

export interface DropdownColorScheme {
    rowHoverColor: string;
    selectedRowColor: string;
}

export default function (colorScheme?: ColorScheme): DropdownColorScheme {
    const themeSymbols = getPalette();
    const textColor = getPaletteAsRawColors().neutralPrimary;
    const dropDownColor = colorScheme
        ? getOptimalTextColorString(textColor, colorScheme, colorScheme.calLighter)
        : themeSymbols.themeLighter;
    return {
        selectedRowColor: dropDownColor,
        rowHoverColor: themeSymbols.neutralLighter,
    };
}
